export enum ProductCodes {
  OnlinePurchaseAllowed = "43432",
}
